import React from "react";
import PrismicDOM from "prismic-dom";
import Helmet from "react-helmet";
import Hero from "../components/Hero";
import ProcessGrid from "../components/ProcessGrid";
import WorkSlider from "../components/WorkSlider";
import Team from "../components/Team";
import { css } from "emotion";
import styled from "react-emotion";
import { theme } from "../styles/theme";
import HomepageFragment from "../fragments/homepage";
import ProcessFragment from "../fragments/process";
import ArticleFragment from "../fragments/article";
import TeamMemberFragment from "../fragments/teamMember";
import { toHtml, noDummy } from "../utilities";

const Cover = styled.div`
  position: relative;
  z-index: 2;
`;

const autoHero = css`
  min-height: initial;
  text-align: center;
  margin-top: ${theme.space5};
  margin-bottom: ${theme.space5};
`;

const theprocess =
  "A collaborative effort between five Western New Yorkers, PandaGoat aims to be the go-to media & marketing agency in the Southern Tier - a one-stop shop of graphic and web design, photography, videography, social media work, aerial footage and marketing strategy. ";

const team =
  "A collaborative effort between five Western New Yorkers, PandaGoat aims to be the go-to media & marketing agency in the Southern Tier - a one-stop shop of graphic and web design, photography, videography, social media work, aerial footage and marketing strategy. ";

export default ({ data }) => {
  const homepage = data.homepage.edges[0].node.data;
  const processItems = data.process.edges;

  return (
    <Cover>
      <Helmet>
        <meta name="description" value={homepage.description} />
      </Helmet>
      <Hero text={homepage.opening_intro.html} />
      <WorkSlider workItems={data.work.edges} />
      <Hero
        text={homepage.process_title}
        subtext={homepage.process_description.html}
        styles={autoHero}
      />
      <ProcessGrid processItems={processItems} />
      <Hero
        text={homepage.team_title}
        subtext={homepage.team_description.html}
        styles={autoHero}
      />
      {console.log("TEAM")}
      <Team team={data.team.edges} />
    </Cover>
  );
};

export const query = graphql`
  query AllPages {
    homepage: allPrismicHomepage {
      edges {
        ...Homepage
      }
    }
    process: allPrismicProcess {
      edges {
        ...ProcessItem
      }
    }
    work: allPrismicArticle(
      sort: { fields: [first_publication_date], order: DESC }
    ) {
      edges {
        ...Article
      }
    }
    team: allPrismicTeamMember {
      edges {
        ...TeamMember
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js